import { active } from "d3";
import paths, { rootPaths } from "./paths";
import { faTemperatureHigh } from '@fortawesome/free-solid-svg-icons';
// Configuración de categorías (cambiar a true para activar agrupación en el futuro)
const USE_CATEGORIES = false;

/**
 * Función para filtrar rutas según permisos de empresa
 * @param {Array} routes - Array de rutas
 * @param {Function} tieneAccesoAReporte - Función para verificar acceso
 * @returns {Array} Rutas filtradas
 */
export const filtrarRutasPorEmpresa = (routes, tieneAccesoAReporte) => {
  return routes.filter(route => {
    // Siempre mostrar Dashboard, separadores y dividers
    if (route.name === "Reportes" || route.type === "divider") {
      return true;
    }
    
    // Verificar acceso para otros reportes
    return tieneAccesoAReporte(route.name);
  });
};

// Iconos sugeridos: usa el set que prefieras (ej: FontAwesome, react-icons, etc)
// Ejemplo: icon: 'fa-solid fa-gauge' o icon: <FontAwesomeIcon icon="fa-gauge" />
// Puedes mapear estos nombres a componentes en tu NavbarVerticalMenuItem

export const dashboardRoutes = {
  label: "Reportes",
  labelDisable: true,
  children: [
    // Dashboard principal (siempre visible como primer elemento)
    {
      name: "Reportes",
      to: rootPaths.root,
      active: true,
      icon: "fa-solid fa-gauge", // Tablero
      category: "principal", // Preparado para futuras agrupaciones
    },

    // Separador visual entre Dashboard y Reportes
    {
      type: "divider",
      //name: "Reportes", // Texto opcional para mostrar en el separador
      category: "separator",
    },

    // Reportes operativos principales
    {
      name: "Alertas",
      to: paths.reporte_alertas,
      active: true,
      icon: "fa-solid fa-bell", // Alertas
      category: "operativos",
      empresaRequerida: null, // Disponible para todas las empresas
    },
    {
      name: "Recorridos",
      to: paths.reporte_recorridos,
      active: true,
      icon: "fa-solid fa-route", // Recorridos
      category: "operativos",
      empresaRequerida: null, // Disponible para todas las empresas
    },
    {
      name: "Apagados / Encendidos",
      to: paths.reporte_apagados_encendidos,
      active: true,
      icon: "fa-solid fa-power-off", // Motor apagado/encendido
      category: "operativos",
      empresaRequerida: "9", // ✅ SOLO EMPRESA 9
    },
    {
      name: "Estadías",
      to: paths.reporte_estadias,
      active: true,
      icon: "fa-solid fa-calendar-check", // Estadías
      category: "operativos",
      empresaRequerida: null, // Disponible para todas las empresas
    },
    {
      name: "Usabilidad",
      to: paths.reporte_usabilidad,
      active: true,
      icon: "fa-solid fa-clock", // Tiempos
      category: "operativos",
      empresaRequerida: null, // Disponible para todas las empresas
    },
    {
      name: "Horario No Laboral",
      to: paths.reporte_horario_no_laboral,
      active: true,
      icon: "fa-solid fa-clock", // Horas no laborales
      category: "operativos",
    },
    {
      name: "Kilómetros",
      to: paths.reporte_km,
      active: true,
      icon: "fa-solid fa-tachometer-alt", // Kilometraje
      category: "operativos",
      empresaRequerida: null, // Disponible para todas las empresas
    },
    {
      name: "Paradas No Autorizadas",
      to: paths.reporte_paradas_no_autorizadas,
      active: true,
      icon: "fa-solid fa-ban", // Paradas no autorizadas
      category: "operativos",
      empresaRequerida: "9", // ✅ SOLO EMPRESA 9
    },

    // Herramientas y utilidades
    {
      name: "Radar",
      to: paths.reporte_puntocercano,
      active: true,
      icon: "fa-solid fa-location-crosshairs", // Buscar punto
      category: "herramientas",
      empresaRequerida: null, // Disponible para todas las empresas
    },
    {
      name: "Consumos",
      to: paths.reporte_consumo,
      active: true,
      // Puedes alternar entre estos dos iconos para probar cuál te gusta más:
      //icon: "fa-solid fa-comments-dollar", // Consumo (comentarios y dinero)
      icon: "fa-solid fa-file-invoice-dollar", // Consumo (factura y dinero)
      category: "herramientas",
      empresaRequerida: "9", // ✅ SOLO EMPRESA 9
    },

    // Administrativos (al final)
    {
      name: "Bitácora",
      to: paths.reporte_bitacora,
      active: true,
      icon: "fa-solid fa-book", // Bitácora
      category: "administrativo",
      empresaRequerida: null, // Disponible para todas las empresas
    },
    {
      name: "Temperatura",
      to: paths.reporte_temperatura,
      active: true,
      icon: "fa-solid fa-temperature-high",
      category: "operativos",
    },
  ],
};

// Exportar array de rutas
const routes = [dashboardRoutes];
export default routes;
